<template>
  <v-form
    ref="form"
    v-model="valid"
    lazy-validation
  >
    <v-row><h5 class="text--disabled">{{ id || 'Network' }} Status</h5></v-row>
    <v-row class="mb-3"><v-divider /></v-row>
    <v-row class="mb-3">
      <videon-state-tile
        heading="MAC Address"
      >
        {{ mac_address }}
      </videon-state-tile>
      <videon-state-tile
        heading="IP Address"
      >
        {{ ipv4_address }}
      </videon-state-tile>
      <videon-state-tile
        heading="Netmask"
      >
        {{ ipv4_netmask }}
      </videon-state-tile>
      <videon-state-tile
        heading="Speed"
      >
        {{ speed }} Mbps
      </videon-state-tile>
    </v-row>
    
    
    <v-row><h5 class="text--disabled">{{ id || 'Network' }} Configuration</h5></v-row>
    <v-row class="mb-3"><v-divider /></v-row>
    <v-row class="mb-3">
      <v-col cols="12">
        <v-btn-toggle
          mandatory
          v-model="config.dhcp_enabled"
          @change="configChanged"
          :disabled="!canEdit"
        >
          <v-btn 
            :value="true"
            :disabled="!canEdit"
            outlined
            small
          >
            DHCP
          </v-btn>
          <v-btn 
            :value="false"
            :disabled="!canEdit"
            outlined
            small
          >
            Manual (Static)
          </v-btn>
        </v-btn-toggle>
      </v-col>
    </v-row>
    <div v-if="!config.dhcp_enabled">
      <v-row class="mb-3">
        <v-col cols="6">
          <v-text-field
            v-model="config.requested_static_configuration.ip_address"
            label="IP Address"
            @input="configChanged"
            :disabled="!canEdit"
            outlined
            hide-details
          ></v-text-field>
        </v-col>
        <v-col cols="6">
          <v-text-field
            v-model="config.requested_static_configuration.netmask"
            label="Subnet Netmask"
            @input="configChanged"
            :disabled="!canEdit"
            outlined
            hide-details
          ></v-text-field>
        </v-col>
      </v-row>
      <v-row class="mb-3">
        <v-col cols="6">
          <v-text-field
            v-model="config.requested_static_configuration.default_gateway"
            label="Gateway IP"
            @input="configChanged"
            :disabled="!canEdit"
            outlined
            hide-details
          ></v-text-field>
        </v-col>
      </v-row>
    
      <v-row class="mb-5" v-if="config.requested_static_configuration && config.requested_static_configuration.dns_servers">
        <v-col cols="6">
          <v-text-field
            v-model="config.requested_static_configuration.dns_servers[0]"
            label="DNS Server 1"
            @input="configChanged"
            :disabled="!canEdit"
            outlined
            hide-details
          ></v-text-field>
        </v-col>
        <v-col cols="6">
          <v-text-field
            v-model="config.requested_static_configuration.dns_servers[1]"
            label="DNS Server 2"
            @input="configChanged"
            :disabled="!canEdit"
            outlined
            hide-details
          ></v-text-field>
        </v-col>
      </v-row>
    </div>
    
    <v-row class="mb-5" v-if="config.route_weight">
      <v-col cols="6">
        <v-text-field
          v-model.number="config.route_weight"
          type="number"
          label="Route Weight"
          @input="configChanged"
          :disabled="!canEdit"
          outlined
          hide-details
        ></v-text-field>
      </v-col>
    </v-row>
    
    <div v-if="id && !isNew && shadowDebug" class="mt-5">
      <v-row><h5 class="text--disabled">Network Details</h5></v-row>
      <v-row class="mb-3"><v-divider /></v-row>
      <v-row class="mb-3">
        <v-col cols="12">
          <pre style="inline-size: 640px; white-space: pre-wrap;">{{ network }}</pre>
        </v-col>
      </v-row>
    </div>
  </v-form>
</template>
<script>
  import { mapGetters } from 'vuex'

  export default {
    name: 'EthernetNetworkDocument',
    
    props: ['network', 'documents', 'device_guid', 'device', 'canEdit', 'isNew'],
    
    data() {
      return {
        valid: true,
        
        id: false,
        type: false,
        
        mac_address: '',
        
        speed: 1000,
        
        up_flag: false,
        running_flag: false,
        
        ipv4_address: '',
        ipv4_netmask: '',
        default_gateway: '',
        
        dns_servers: [],
        
        config: {
          dhcp_enabled: false,
          requested_static_configuration: {
            default_gateway: '',
            ip_address: '',
            netmask: '',
            dns_servers: []
          },
          route_weight: 10
        }
      }
    },
    
    watch: {
      network() {
        this.updateValues()
      }
    },
    
    computed: {
      ...mapGetters('userPreferences', ['shadowDebug']),
    },
    
    mounted() {
      this.updateValues()
    },
    
    methods: {
      configChanged() {
        console.log('EthernetNetworkDocument ' + this.device_guid + ' configChanged', this.config)
        
        if (!this.config.dhcp_enabled && !this.config.requested_static_configuration) {
          this.config.requested_static_configuration = {
            default_gateway: (this.default_gateway) ? this.default_gateway : '',
            ip_address: (this.ipv4_address) ? this.ipv4_address : '',
            netmask: (this.ipv4_netmask) ? this.ipv4_netmask : '',
            dns_servers: (this.dns_servers) ? this.dns_servers : []
          }
        }
        
        this.$emit('configUpdate', this.config)
      },
      
      updateValues() {
        if (this.network && this.network.config) {
          Object.keys(this.network).map((key) => {
            this[key] = this.network[key]
          })
          
          // htmlDecode name properties
          if (this.config.name) {
            this.config.name = this.$helpers.htmlDecode(this.config.name)
          }
        }
        
        this.configChanged()
      },
    }
  }
</script>